<template>
    <div v-if="visitedProducts.length">
        <v-card-title>{{$t('youViewedEarlier')}}</v-card-title>
        <v-divider></v-divider>
        <v-slide-group
            v-model="visitedProducts"
            class="pa-4"
            active-class="success"
            show-arrows
        >
            <v-slide-item
                v-for="product in visitedProducts"
                :key="product.id"
            >
                <div class="px-2" style="max-width: 250px">
                    <product-card
                        class="general_card px-4"
                        :product="product"
                    ></product-card>
                </div>
            </v-slide-item>
        </v-slide-group>
        <v-divider></v-divider>
    </div>
</template>

<script>
import ProductCard from '../general-card/GeneralCard';
import ProductService from '../../../../app-front/services/api/ProductService';

export default {
    props: {
        productsIds: {
            required: true,
            type: Array
        }
    },
    components: {ProductCard},
    data() {
        return {
            visitedProducts: [],
        }
    },
    created() {
        this.getProducts();
    },
    methods: {
        getProducts() {
            const params = { product_id: this.productsIds };

            ProductService.setLocale(this.$store.state.language.appLanguage);
            ProductService.getList(params, 1, null, {})
                .then(res => {
                    const products = res.data.data;
                    this.visitedProducts = this.productsIds.map(id => {
                        const idx = products.findIndex(product => product.id === +id);
                        const product = products[idx];
                        products.splice(idx, 1);
                        return product;
                    }).filter(item => item);
                })
                .catch(err => {
                    console.log(err);
                })
        }
    },
}
</script>

<style scoped>
.general_card {
    width: 280px!important;
}
/*Mobile version*/
@media screen and (max-width: 800px) {
    .general_card {
        width: 240px!important;
    }
}
</style>
